import type { QueueBoardRoom } from "../types";
import { queueFont } from "../queueFont";
import { WelcomeHeader } from "./WelcomeHeader";
import { CareCornerLogo } from "./CareCornerLogo";

type SingleRoomBoardProps = {
  clinicName: string;
  clinicLogoUrl: string;
  hasClinicLogo: boolean;
  room: QueueBoardRoom;
};

export function SingleRoomBoard({ clinicName, clinicLogoUrl, hasClinicLogo, room }: SingleRoomBoardProps) {
  const queueText = String(room.currentQueue);
  const roomNo = String(room.id ?? "").trim();
  const title = String(room.name ?? "").trim();
  const roomLabel = roomNo ? `Room ${roomNo}` : "";
  const titleLooksLikeRoom =
    !!roomNo &&
    (title.toLowerCase() === roomLabel.toLowerCase() ||
      title.toLowerCase() === roomNo.toLowerCase());
  const showTitle = !!title && !titleLooksLikeRoom;

  return (
    <div
      className={`${queueFont} relative box-border flex min-h-screen w-full max-w-[100vw] select-none flex-col items-center justify-center overflow-hidden bg-white px-[clamp(20px,3.5vmin,64px)] pb-[clamp(96px,11vmin,160px)] pt-[clamp(20px,3.5vmin,64px)] antialiased`}
    >
      <CareCornerLogo variant="wall" />

      <WelcomeHeader clinicName={clinicName} />

      <div
        className={`${queueFont} mb-[clamp(8px,1.5vmin,16px)] mt-[clamp(100px,14vmin,200px)] px-[clamp(20px,3.5vmin,64px)] text-center`}
      >
        {showTitle ? (
          <div
            className={`${queueFont} text-[clamp(18px,2.8vmin,32px)] font-bold tracking-wide text-[#0b3a66] [text-rendering:optimizeLegibility]`}
          >
            {title}
          </div>
        ) : null}
        {roomLabel ? (
          <div
            className={`${queueFont} ${showTitle ? "mt-[clamp(4px,0.8vmin,10px)]" : ""} text-[clamp(22px,3.6vmin,42px)] font-bold tracking-wide text-[#0b3a66] [text-rendering:optimizeLegibility]`}
          >
            {roomLabel}
          </div>
        ) : null}
        <div
          className={`${queueFont} mt-[clamp(6px,1vmin,14px)] text-[clamp(18px,2.9vmin,34px)] font-semibold text-[#334155] [text-rendering:optimizeLegibility]`}
        >
          {room.doctorName}
        </div>
      </div>

      <div
        className={`${queueFont} mb-[clamp(8px,1.5vmin,20px)] text-[clamp(14px,2vmin,26px)] font-bold tracking-[0.12em] text-[#334155]`}
      >
        NOW SERVING
      </div>

      <div className="flex flex-wrap items-center justify-center gap-[clamp(16px,3vmin,40px)]">
        <div
          className={`${queueFont} text-[clamp(152px,26vmin,420px)] font-extrabold leading-none text-[#0b3a66] [font-variant-numeric:tabular-nums] [text-rendering:optimizeLegibility]`}
        >
          {queueText}
        </div>

        {hasClinicLogo ? (
          <>
            <div className="min-h-[clamp(80px,14vmin,160px)] w-[clamp(2px,0.35vmin,4px)] self-stretch rounded-full bg-[#cbd5e1]" />
            <img
              src={clinicLogoUrl}
              alt=""
              className="h-[clamp(72px,14vmin,140px)] w-[clamp(72px,14vmin,140px)] object-contain"
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
